import { useState, useCallback } from 'react';

function useLayouts() {
  var _useState = useState(),
    containerLayout = _useState[0],
    setContainerLayout = _useState[1];
  var _useState2 = useState(),
    itemLayout = _useState2[0],
    setItemLayout = _useState2[1];
  var onLayoutItem = useCallback(function (_ref) {
    var nativeEvent = _ref.nativeEvent;
    return setItemLayout(nativeEvent.layout);
  }, [setItemLayout]);
  var onLayoutContainer = useCallback(function (_ref2) {
    var nativeEvent = _ref2.nativeEvent;
    return setContainerLayout(nativeEvent.layout);
  }, [setContainerLayout]);
  return {
    containerLayout: containerLayout,
    itemLayout: itemLayout,
    onLayoutContainer: onLayoutContainer,
    onLayoutItem: onLayoutItem
  };
}

export { useLayouts as default };
//# sourceMappingURL=useLayouts.js.map
